export default __webpack_public_path__ + "static/Seeds Donation-a373af631e9845b265d2af0048ef626e.png";